import { UserAsset } from './types';

// Bộ sách lấy tên từ bộ, không từ book (asset_id của bộ không phải id sách).
export const getAssetTitle = (asset: UserAsset) =>
  (asset.asset_type === 'collection' ? asset.book_collection?.title : asset.book?.title) || '';

export const getAssetCover = (asset: UserAsset) =>
  asset.asset_type === 'collection'
    ? asset.book_collection?.cover_image_url
    : asset.book?.cover_image_url || asset.book?.cover_image;

// User model của API trả email trong `mail`; `email` chỉ có ở dữ liệu cũ.
export const getUserContacts = (user: UserAsset['user']) =>
  [user?.mail || user?.email, user?.phone].filter((value): value is string => !!value);

// BE giữ message tiếng Anh cố định vì app reader dò theo chuỗi này (UserAssetDownloadException).
const DOWNLOAD_ERROR_MESSAGES: Array<[string, string]> = [
  ['You do not have access to this asset', 'Chỉ chính người sở hữu mới tải được tài sản này.'],
  ['has been revoked', 'Tài sản đã bị thu hồi.'],
  // Đứng trước 'has expired' vì message này cũng chứa cụm đó
  ['not active or has expired', 'Tài sản không còn hoạt động.'],
  ['has expired', 'Tài sản đã hết hạn.'],
  ['has been suspended', 'Tài sản đang tạm dừng.'],
  ['Download limit reached', 'Tài sản đã hết suất thiết bị tải.'],
  ['Only book assets can be downloaded', 'Chỉ tải được tài sản loại sách.'],
  ['No published version', 'Sách chưa có bản phát hành.'],
  ['Book not found', 'Sách gốc không còn tồn tại.'],
  ['User asset not found', 'Tài sản không tồn tại hoặc đã bị xoá.'],
];

// Request tải dùng responseType 'blob' nên body lỗi cũng là Blob, phải đọc ra JSON.
export const getDownloadErrorMessage = async (error: any): Promise<string> => {
  // 401 ("Token has expired") là hết phiên, interceptor tự chuyển về đăng nhập;
  // không được khớp nhầm vào cụm 'has expired' của tài sản.
  if (error?.response?.status === 401) {
    return 'Tải xuống thất bại: phiên đăng nhập đã hết, vui lòng đăng nhập lại.';
  }

  let message = '';
  try {
    const data = error?.response?.data;
    const body = data instanceof Blob ? JSON.parse(await data.text()) : data;
    message = String(body?.message ?? '');
  } catch {
    // Body không phải JSON (lỗi mạng, proxy): dùng câu chung
  }
  const known = DOWNLOAD_ERROR_MESSAGES.find(([fragment]) => message.includes(fragment));
  return `Tải xuống thất bại: ${known ? known[1] : 'vui lòng thử lại.'}`;
};

// Ưu tiên cờ API trả; API chưa có thì suy ra cùng điều kiện server dùng để chặn tải.
export const getAssetFlags = (asset: UserAsset, now = Date.now()) => {
  const isExpired =
    asset.is_expired ?? (!!asset.expires_at && new Date(asset.expires_at).getTime() < now);
  const isActive = asset.is_active ?? (asset.status === 'active' && !isExpired);
  const canDownload =
    asset.can_download ??
    (isActive &&
      asset.asset_type === 'book' &&
      (asset.downloads_remaining == null || asset.downloads_remaining > 0));

  return { isExpired, isActive, canDownload };
};
